module.exports = __webpack_public_path__ + "static/insightsBack-b5b1aed7d95b679b41073643692cab11.jpg";